import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SummaryFinances } from './Summary/SummaryFinances';
import { TransactionList } from './TransactionList/TransactionList';

const Finances = () => {
  const usersLinks = [
    {
      link: 'summary',
      element: <SummaryFinances />
    },
    {
      link: 'transaction-list',
      element: <TransactionList />
    }
  ];

  return (
    <Routes>
      {usersLinks.map((link) => (
        <Route key={link.link} path={`/${link.link}/*`} element={link.element} />
      ))}
    </Routes>
  );
};

export default Finances;
